import { render, staticRenderFns } from "./invoiceWidget.vue?vue&type=template&id=04dfab21&scoped=true&"
import script from "./invoiceWidget.vue?vue&type=script&lang=js&"
export * from "./invoiceWidget.vue?vue&type=script&lang=js&"
import style0 from "./invoiceWidget.vue?vue&type=style&index=0&id=04dfab21&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04dfab21",
  null
  
)

export default component.exports